import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_HERO_PROMOS } from 'actions/apiActionConstants'
import { getMerchandiseHeroCarousel } from 'api/content'

function fetchMerchandiseHeroPromos(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.merchandise.merchandiseHeroPromos) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_HERO_PROMOS,
      request: () => getMerchandiseHeroCarousel('au-marketplace'),
    })
  }
}

export default fetchMerchandiseHeroPromos
